import axios from "./axios";
import createReservation from "./createReservation";
import deleteReviewReply from "./deleteReviewReply";
import deleteUser from "./deleteUser";
import fetchAll from "./fetchAll";
import fetchAllStripeSubscriptions from "./fetchAllStripeSubscriptions";
import fetchBusinesses from "./fetchBusinesses";
import fetchBusinessOnce from "./fetchBusinessOnce";
import fetchCollection from "./fetchCollection";
import fetchDelete from "./fetchDelete";
import fetchDoc from "./fetchDoc";
import fetchPromo from "./fetchPromo";
import fetchRaffles from "./fetchRaffles";
import fetchTags from "./fetchTags";
import get from "./get";
import get2 from "./get2";
import getEstimatedWait from "./getEstimatedWait";
import logError from "./logError";
import logTransaction from "./logTransaction";
import logVisit from "./logVisit";
import observeBlockTables from "./observeBlockTables";
import observeBusiness from "./observeBusiness";
import observeBusinesses from "./observeBusinesses";
import observeBusinessGroupPermissions from "./observeBusinessGroupPermissions";
import observeBusinessGroups from "./observeBusinessGroups";
import observeBusinessGroupUsers from "./observeBusinessGroupUsers";
import observeBusinessUsers from "./observeBusinessUsers";
import observeCollection from "./observeCollection";
import observeFeedback from "./observeFeedback";
import observeGroupBusinesses from "./observeGroupBusinesses";
import observeGroupPermissions from "./observeGroupPermissions";
import observeInvoices from "./observeInvoices";
import observePermissions from "./observePermissions";
import observeReports from "./observeReports";
import observeRestaurantPayments from "./observeRestaurantPayments";
import observeRestaurantSettlements from "./observeRestaurantSettlements";
import observeReviewHq from "./observeReviewHq";
import observeSms from "./observeSms";
import observeSubscriptions from "./observeSubscriptions";
import observeTags from "./observeTags";
import observeTransactions from "./observeTransactions";
import observeUser from "./observeUser";
import observeVisits from "./observeVisits";
import post from "./post";
import postUnsafe from "./postUnsafe";
import removeCustomer from "./removeCustomer";
import sendReviewReply from "./sendReviewReply";

export default {
  createReservation,
  deleteUser,
  fetchDoc,
  fetchCollection,
  fetchAll,
  fetchAllStripeSubscriptions,
  fetchBusinesses,
  observeCollection,
  observePermissions,
  fetchBusinessOnce,
  fetchPromo,
  fetchRaffles,
  fetchTags,
  get,
  get2,
  getEstimatedWait,
  observeBlockTables,
  observeBusinesses,
  observeBusiness,
  observeFeedback,
  observeInvoices,
  observeReports,
  observeReviewHq,
  observeRestaurantSettlements,
  observeRestaurantPayments,
  observeTags,
  observeUser,
  observeVisits,
  observeSms,
  observeSubscriptions,
  observeTransactions,
  logError,
  logTransaction,
  logVisit,
  post,
  postUnsafe,
  fetchDelete,
  removeCustomer,
  sendReviewReply,
  deleteReviewReply,
  axios,
  observeBusinessUsers,
  observeBusinessGroupUsers,
  observeGroupBusinesses,
  observeGroupPermissions,
  observeBusinessGroupPermissions,
  observeBusinessGroups,
};
